'use client';

import type { ABTestVariantResult } from '@repo/platform-absmartly/utils/variants';
import DOMPurify from 'dompurify';
import { useEffect, useState } from 'react';

export function ExperimentDecisionWindowInjection({
  experimentResult,
}: {
  experimentResult: ABTestVariantResult;
}) {
  const [sanitized, setSanitized] = useState('');

  useEffect(() => {
    setSanitized(experimentResult);
  }, []);

  if (!sanitized) return null;

  return (
    <template
      dangerouslySetInnerHTML={{
        __html: `window.__pageDecision__="${DOMPurify.sanitize(experimentResult)}";`,
      }}
    />
  );
}
